import { useTranslation } from 'next-i18next'

import DrillTopicElementsList from '~/components/Drill/DrillTopic/components/DrillTopicElemetsList'
import DrillTopicGridLayout from '~/components/Drill/DrillTopic/components/DrillTopicGridLayout'
import DrillTopicGridWrapper from '~/components/Drill/DrillTopic/components/DrillTopicGridWrapper'
import LianaDesktop from '~/components/Drill/DrillTopic/components/LianaDesktop'
import LianaMobile from '~/components/Drill/DrillTopic/components/LianaMobile'
import LianaTablet from '~/components/Drill/DrillTopic/components/LianaTablet'

import useGetGridPositionFunction from '~/components/Drill/hooks/useGetGridPositionFunction'
import { TopicData } from '~/types/theory'
import { processTopics } from '~/components/Drill/DrillTopic/helpers'

import { getGridPosition } from './Parentheses.grid'
import { getProperties } from './Parentheses.properties'

export default function Parentheses({
  topics,
  drillUrl,
}: {
  topics: TopicData[] | undefined
  drillUrl: string
}): React.ReactElement {
  const { t } = useTranslation(['drill'])
  const getGridPositionFunction = useGetGridPositionFunction(getGridPosition)
  const processedTopics = processTopics(topics, getGridPositionFunction, getProperties)

  const mobileGridRows = 'grid-rows-[repeat(20,70px)]'
  const tabletGridRows = 'md:grid-rows-[repeat(10,70px)]'
  const desktopGridRows = 'xl:grid-rows-[repeat(8,70px)]'
  return (
    <DrillTopicGridWrapper>
      <div className="md:hidden">
        <LianaMobile height={1900} />
      </div>
      <div className="hidden md:block xl:hidden">
        <LianaTablet
          height={896}
          image="math-drills/parentheses/beanstalk-tablet.png"
          imageAlt={t('drill:imageAlt.parenthesesBeanStalkDesktop')}
        />
      </div>
      <div className="hidden xl:block">
        <LianaDesktop
          classNames="-top-32 left-14 w-[785px]"
          height={1080}
          image="math-drills/parentheses/beanstalk-desktop.png"
          imageAlt={t('drill:imageAlt.parenthesesBeanStalkTablet')}
        />
      </div>
      <DrillTopicGridLayout className={`mb-20 ${[mobileGridRows, tabletGridRows, desktopGridRows].join(' ')}`}>
        <DrillTopicElementsList drillUrl={drillUrl} topics={processedTopics} />
      </DrillTopicGridLayout>
    </DrillTopicGridWrapper>
  )
}
